import { CardProp } from '../types'

import { useIsMobile } from '@hooks/use-media-query'

import { Wrapper, WrapperCard, Text, Title, CardImage } from './styles'

export function Card({
  isRowReverse,
  title,
  text,
  image,
  imageMobile,
  textWidth,
}: CardProp) {
  const isMobile = useIsMobile()

  return (
    <Wrapper>
      <Title as="h3">{title}</Title>
      <WrapperCard isRowReverse={isRowReverse}>
        <Text textWidth={textWidth}>{text}</Text>
        <CardImage
          isRowReverse={isRowReverse}
          {...(isMobile ? imageMobile : image)}
        />
      </WrapperCard>
    </Wrapper>
  )
}
